import React from 'react'
import { NgsoRoute, useRouter } from '@src/routes'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { Grid, Box, Checkbox, FormControlLabel } from '@material-ui/core'
import { configContext } from '../Ngso'
import messages from '../../../messages'
import { FormattedMessage } from 'react-intl'
import { ActiveLinkType, ProductType } from '../enum'
import NgsoPlates from './NgsoPlates'
import NgsoTubes from './NgsoTubes'

import {
  usePlateSessionFieldMutation,
  usePlateTotalValidationMutation,
} from '@src/mutations/ConfiguratorTubesMutation.generated'
import { useGetNgsoPriceCallLazyQuery } from '@src/queries/ConfiguratorTubesQuery.generated'
import { EmptyNgsoSession } from '../EmptySession'
import CircleLoader from '@src/components/CircleLoader'

const useStyles = makeStyles((theme: Theme) => {
  return {
    container: {
      border: `1px solid ${theme.palette.grey[400]}`,
      padding: theme.spacing(6),
    },
    heading: {
      marginBottom: theme.spacing(6),
      fontSize: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      textTransform: 'uppercase',
      fontFamily: 'Lato',
      lineHeight: '1.2',
      letterSpacing: '1.5px',
    },
    checkboxLabel: {
      fontSize: theme.typography.pxToRem(14),
      marginLeft: theme.spacing(-1),
      marginRight: theme.typography.pxToRem(80),
      textTransform: 'capitalize',
      letterSpacing: 'normal',
    },
    checkbox: {
      padding: 0,
      paddingRight: theme.typography.pxToRem(8),
      paddingLeft: theme.typography.pxToRem(25),
      paddingBottom: theme.typography.pxToRem(3),
      color: theme.palette.grey[500],
    },
  }
})

export const ConfirmOrder = (props) => {
  const classes = useStyles()
  const router = useRouter()
  const { state, dispatch } = React.useContext(configContext)
  const { productDetails, configuratorAddToMiniCart } = props
  const { sessionData, isPageLoad, productInformation } = state
  const [override, setOverride] = React.useState(
    sessionData[0].isSpecificationsOverridden
  )
  const [plateTotalValidation, { loading }] = usePlateTotalValidationMutation()
  const [ngsosessionField, { loading: sessionLoaded }] =
    usePlateSessionFieldMutation()
  const [getNgsoPriceCall, { data, loading: priceLoading }] =
    useGetNgsoPriceCallLazyQuery({
      fetchPolicy: 'no-cache',
    })

  const fetchPrice = async (obj) => {
    await getNgsoPriceCall({
      variables: { product: obj },
    })
  }
  const saveSessionHandler = async (sessionData, isCallPriceApi) => {
    let sessioncallcompleted = false
    if (sessionData.length !== 0) {
      dispatch({
        type: 'UPDATE_NGSO_INPUT',
        data: [...sessionData],
      })
    }
    const response = await ngsosessionField({
      variables: { input: sessionData, productInput: productDetails },
    })
    sessioncallcompleted = response.data?.plateSessionField ? true : false
    if (sessioncallcompleted && isCallPriceApi) {
      await getNgsoPriceCall({
        variables: { product: productDetails },
      })
    }
  }

  const handlePrev = () => {
    window.scrollTo(0, 0)
    router.push(
      NgsoRoute.navigate(productDetails.type, ActiveLinkType.EntryMethod)
    )
  }
  React.useEffect(() => {
    if (isPageLoad) {
      const hasProductData = sessionData[0].wellList.find((item) => item.name)
      setOverride(sessionData[0].isSpecificationsOverridden)
      if (!hasProductData) {
        handlePrev()
      } else {
        fetchPrice(productDetails)
      }
    }
  }, [isPageLoad])

  React.useEffect(() => {
    if (
      data &&
      !data?.getNgsoPriceCall?.serverError &&
      data?.getNgsoPriceCall?.response
    ) {
      data.getNgsoPriceCall.response.forEach((plate, plateIndex) => {
        if (plate?.wellList) {
          plate.wellList.forEach((well, wellIndex) => {
            if (sessionData[plateIndex].wellList[wellIndex]) {
              sessionData[plateIndex].wellList[wellIndex].price = well?.price
                ? well.price
                : ''
              sessionData[plateIndex].wellList[wellIndex].priceHeaderError =
                well?.priceHeaderError ? well.priceHeaderError : ''
              sessionData[plateIndex].wellList[wellIndex].currencySymbol =
                well?.currencySymbol ? well.currencySymbol : ''
              sessionData[plateIndex].wellList[wellIndex].currency =
                well?.currency ? well.currency : ''
            }
          })
        }
      })
      dispatch({
        type: 'UPDATE_NGSO_INPUT',
        data: [...state.sessionData],
      })
    }
    // TODO: need a test before we refactor these dependencies
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const clearSession = (isNavigateToStep1) => {
    sessionData.splice(0, sessionData.length)
    sessionData.push(EmptyNgsoSession)
    sessionData.forEach((data) => {
      delete data.__typename
      data.wellList.forEach((well) => {
        delete well.__typename
      })
    })
    dispatch({
      type: 'UPDATE_NGSO_INPUT',
      data: [...sessionData],
    })
    dispatch({ type: 'SET_STEP_NO', data: 0 })
    saveSessionHandler([], false)
    if (isNavigateToStep1) {
      handlePrev()
    }
  }
  const totalValidation = async (sessionData, callPriceApi) => {
    const response: any = await plateTotalValidation({
      variables: { input: sessionData, productInput: productDetails },
    })
    const { data } = response
    let isClearSession = false
    if (data && !data.plateTotalValidation.serverError) {
      if (productDetails.type === ProductType.NgsoTubes) {
        const listNgso =
          data.plateTotalValidation.response[0].wellList[0].listNgso
        sessionData.forEach((plate) => {
          plate.wellList.forEach((well) => {
            well.listNgso = listNgso
            if (well.ngsoType && !listNgso?.includes(well.ngsoType)) {
              well.ngsoType = ''
            }
          })
        })
      } else if (productDetails.type === ProductType.NgsoPlates) {
        data.plateTotalValidation.response.forEach((plate) => {
          if (plate.error?.length !== 0) {
            dispatch({
              type: 'SET_ERROR_FROM_CONFIRM_ORDER',
              data: plate.error,
            })
            isClearSession = true
          }
        })
      }
    } else {
      window.scrollTo(0, 0)
    }
    if (isClearSession) {
      clearSession(true)
    } else {
      dispatch({ type: 'SET_ERROR_FROM_CONFIRM_ORDER', data: '' })
      saveSessionHandler(sessionData, callPriceApi)
    }
  }
  const handleOverride = (value) => {
    setOverride(value)
    sessionData.forEach((data) => {
      data.isSpecificationsOverridden = value
    })
    totalValidation(sessionData, true)
  }
  return (
    <Box className={classes.container}>
      <Grid container direction="row">
        <Grid item className={classes.heading}>
          <FormattedMessage {...messages.CONFIRM_ORDER} />
        </Grid>
        {productDetails.isCSRSupervisor ? (
          <Grid item className={classes.heading}>
            <FormControlLabel
              classes={{ label: classes.checkboxLabel }}
              control={
                <Checkbox
                  value={override}
                  checked={override}
                  className={classes.checkbox}
                  onChange={() => {
                    handleOverride(!override)
                  }}
                />
              }
              label={
                <FormattedMessage {...messages.CONF_OVERRIDE_VALIDATION} />
              }
            />
          </Grid>
        ) : (
          ''
        )}
      </Grid>
      <Grid container>
        {productDetails.type === ProductType.NgsoTubes && (
          <NgsoTubes
            handlePrev={handlePrev}
            sessionData={sessionData}
            productInformation={productInformation}
            saveSessionHandler={saveSessionHandler}
            productDetails={productDetails}
            clearSession={clearSession}
            totalValidation={totalValidation}
            configuratorAddToMiniCart={configuratorAddToMiniCart}
          />
        )}
        {productDetails.type === ProductType.NgsoPlates && (
          <NgsoPlates
            handlePrev={handlePrev}
            productDetails={productDetails}
            saveSessionHandler={saveSessionHandler}
            clearSession={clearSession}
            totalValidation={totalValidation}
            configuratorAddToMiniCart={configuratorAddToMiniCart}
            isCSR={props.isCSR}
          />
        )}
      </Grid>
      {(loading || priceLoading || sessionLoaded) && <CircleLoader />}
    </Box>
  )
}

export default ConfirmOrder
